module.exports = __webpack_public_path__ + "static/media/iclearpass-logo.df85e936.png";